import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setFilter } from '../actions/notifications'
import { openPopover } from '../actions/popover'
import { me } from '../initial_state'
import {
  NOTIFICATION_FILTERS,
  BREAKPOINT_EXTRA_SMALL,
  POPOVER_NOTIFICATION_SETTINGS,
} from '../constants'
import PageTitle from '../features/ui/util/page_title'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import DefaultLayout from '../layouts/default_layout'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import { shuffle } from 'lodash'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import NotificationFilterPanel from '../components/panel/notification_filter_panel'

const titles = {
  notifications: 'Notifications' ,
  mention: 'Mentions',
  favourite: 'Reactions',
  reblog: 'Reposts',
  poll: 'Poll',
  follow: 'Follows',
  follow_requests: 'Follow requests',
  quote: 'Quotes',
  all: 'All',
}

class NotificationsPage extends React.PureComponent {

  onChangeActiveFilter(notificationType) {
    this.props.dispatch(setFilter('active', notificationType))
    let href

    if (notificationType === 'all') {
      href = '/notifications'
    } else if (notificationType === 'follow_requests') {
      href = `/notifications/follow_requests`
    } else {
      href = `/notifications?view=${notificationType}`
    }

    this.props.history.push(href)
    
    // otherwise it can stay scrolled down
    window.scrollTo(0, 0)
  }

  handleOnClickSettings = () => {
    this.props.dispatch(openPopover(POPOVER_NOTIFICATION_SETTINGS, {
      targetRef: this.node,
    }))
  }

  setNode = (n) => {
    this.node = n
  }

  render() {
    const {
      children,
      locked,
      notificationCount,
      selectedFilter,
      isXS,
    } = this.props

    let filters = NOTIFICATION_FILTERS
    if (!locked && filters.indexOf('follow_requests') > -1) {
      filters.splice(filters.indexOf('follow_requests'))
    }

    const tabs = filters.map((filter) => ({ 
      title: titles[filter],
      onClick: () => this.onChangeActiveFilter(filter),
      active: selectedFilter.toLowerCase() === filter.toLowerCase()
    }))

    const title = 'Notifications'

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='notifications-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'notifications.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='notifications-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'notifications.sidebar', position: 1 }} />
    ]

    const layout = [
      <NotificationFilterPanel noPanel />,
      <WrappedBundle key='notifications-page-ad-panel' component={GabAdTopPanel} componentParams={{ noPanel: true, pageKey: 'notifications.sidebar', position: 3 }} />,
    ]

    return (
      <DefaultLayout
        title={title}
        page='notifications'
        layout={sidebarLayout}
        tabs={tabs}
        actions={isXS ? [
          {
            icon: 'cog',
            onClick: this.handleOnClickSettings
          },
        ] : undefined}
        sidebarChildren={<SidebarPanelGroup layout={layout} /> }
      >
        {/* just do empty node because it only shows on mobile */}
        <div ref={this.setNode} />
        <PageTitle badge={notificationCount} path={title} />
        {children}
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedFilter: state.getIn(['notifications', 'filter', 'active']),
  notificationCount: state.getIn(['notifications', 'unread']),
  locked: !!state.getIn(['accounts', me, 'locked']),
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

NotificationsPage.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  locked: PropTypes.bool,
  notificationCount: PropTypes.number.isRequired,
  selectedFilter: PropTypes.string.isRequired,
}

export default withRouter(connect(mapStateToProps)(NotificationsPage))